import Generic from "./Generic";

export default class ExamEvent {
    static ajaxSelectorLoad(element, url, search_data, value, placeholder, callback)
    {
        $.ajax({
            type: "GET",
            url: url,
            data: search_data,
            dataType: 'json',
            async: true,
            success: function (response) {
                if( response.status === true ) {
                    $(element).empty(); // Clear existing options
                    $(element).append("<option value=''>" + placeholder + "</option>");
                    $.each(response.data, function(key, name) {
                        $(element).append("<option value='" + key + "'>" + name + "</option>");
                    });
                    if(value != ''){
                        $(element).val(value);
                    }
                    if (callback !== undefined){
                        callback(response.status, response.data, response.message);
                    }
                }
                else alert('Something Went Wrong!');
            }
        });
    }

    static loadAcademicYears(element, value, placeholder, callback){
        this.ajaxSelectorLoad(
            element,
            "ajax/ajax_exam_event/get_academic_year_options",
            {},
            value,
            placeholder,
            callback
        );
    }

    static loadDepartments(element, academic_year_id, value, placeholder, callback){
        this.ajaxSelectorLoad(
            element,
            "ajax/ajax_exam_event/get_department_options",
            {'academic_year_id': academic_year_id},
            value,
            placeholder,
            callback
        );
    }

    static loadMajors(element, academic_year_id, department_id, value, placeholder, callback){
        this.ajaxSelectorLoad(
            element,
            "ajax/ajax_exam_event/get_major_options",
            {'academic_year_id': academic_year_id, 'department_id': department_id},
            value,
            placeholder,
            callback
        );
    }

    static loadExamEvents(element, academic_year_id, major_id, category, value, placeholder, callback){
        this.ajaxSelectorLoad(
            element,
            "ajax/ajax_exam_event/get_exam_event_options",
            {'academic_year_id': academic_year_id, 'major_id': major_id, 'category': category},
            value,
            placeholder,
            callback
        );
    }

    static loadExamEventRooms(element, exam_event_id, value, placeholder, callback){
        this.ajaxSelectorLoad(
            element,
            "ajax/ajax_exam_event/get_exam_event_room_options",
            {'exam_event_id': exam_event_id},
            value,
            placeholder,
            callback
        );
    }

    /**
     * Recursive AJAX loader for grade level options by major ids
     * @param {number|string} academicYearId
     * @param {string} category
     * @param {Array<number|string>} majorIds
     * @param {number} index Current index in majorIds
     * @param {any} gradeLevelId Optional grade level filter
     * @param {function} callback Function called with accumulated results after all calls
     * @param {Array} results Accumulated results (used internally)
     */
    static getGradeLevelOptions(academicYearId, category, majorIds = [], index = 0, gradeLevelId = null, callback, results = []) {
        $('.ajax-loader').show();
        if (index >= majorIds.length) {
            $('.ajax-loader').hide();
            if (typeof callback === 'function') {
                callback(results);
            }
            return;
        }

        $.ajax({
            method: "GET",
            url: "/exam-event/get-grade-level-options",
            data: {
                academic_year_id: academicYearId,
                category: category,
                major_id: majorIds[index],
                grade_level_id: gradeLevelId,
            },
            success: (response) => {
                if (response.status) {
                    ExamEvent.mergeItemsToHiddenInput(response.items);
                    ExamEvent.getGradeLevelOptions(
                        academicYearId,
                        category,
                        majorIds,
                        index + 1,
                        gradeLevelId,
                        callback,
                        results.concat(response.items || [])
                    );
                } else {
                    swal({
                        type: "error",
                        icon: 'error',
                        title: 'Oops...',
                        text: response.error || 'Unknown error occurred',
                        button: 'OK'
                    });
                }
            },
            error: (xhr) => {
                let errorMessage = 'Something went wrong!';
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMessage = xhr.responseJSON.message;
                } else if (xhr.responseText) {
                    errorMessage = xhr.responseText;
                }
                swal({
                    type: "error",
                    icon: 'error',
                    title: 'Oops...',
                    text: errorMessage,
                    button: 'OK'
                });
            }
        });
    }

    /**
     * Merges new items' IDs into a single hidden input's comma-separated value.
     * @param {Array} items Array of objects or primitive IDs
     */
    static mergeItemsToHiddenInput(items) {
        const input = $('input[name="grade_level_ids"]');
        let currentVal = input.val() || '[]';

        let existingItems;
        try {
            existingItems = JSON.parse(currentVal);
            if (!Array.isArray(existingItems)) {
                existingItems = [];
            }
        } catch {
            existingItems = [];
        }

        const existingIds = new Set(existingItems.map(i => String(i.id)));

        items.forEach(item => {
            const id = String(item.id ?? item);
            const major_id = item.major_id ?? null;

            if (!existingIds.has(id)) {
                existingItems.push({ id, major_id });
                existingIds.add(id);
            }
        });

        input.val(JSON.stringify(existingItems));
    }
}
